import React from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { formatCurrency } from '../../service/format';

export default function FuelByDriver(props){

    return (
        <>
             <div className="col-12 xl:col-12">
                <div className="card">
                    <div className="flex justify-content-between align-items-center mb-5">
                        <h5>Consumo de Combustível <br /><small style={{ fontSize: 10 }}> Por Motorista</small></h5>
                    </div>
                    <DataTable value={props?.fuelConsumptionByDriver?.map(data => {
                        var kmtotal = data.km;

                        return {
                            ...data,
                            kmtotal,
                            percent: formatCurrency(parseFloat(data.litres ? (((kmtotal || 0) / data.litres) + 0.3) : 0).toFixed(2)),
                        }
                    })} rows={10} emptyMessage="Nenhum registro." responsiveLayout="scroll">
                        <Column field="name" header="Motorista"></Column>
                        <Column field="kmtotal" header="Km Rodados"></Column>
                        <Column field="litres" header="Litros"></Column>
                        <Column field="percent" style={{ whiteSpace: "nowrap" }} header="Consumo Aprox. (Km / L)"></Column>
                    </DataTable>
                </div>
            </div>
        </>
    )

}